import { render, staticRenderFns } from "./EditBaseProductPage.vue?vue&type=template&id=793348b7&scoped=true"
import script from "./EditBaseProductPage.vue?vue&type=script&lang=js"
export * from "./EditBaseProductPage.vue?vue&type=script&lang=js"
import style0 from "./EditBaseProductPage.vue?vue&type=style&index=0&id=793348b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793348b7",
  null
  
)

export default component.exports